import React, { createContext, useContext } from 'react';
import { ProjectPhase } from 'api/project';
import { Sprint } from 'api/sprint-planning/types';
import { Task } from 'data/tasks';
import { List } from 'utils/date-shift';
import { useListData } from './use-list-data';

type ListDataContext = {
  taskList: List;
  sprintList: List;
  phaseList: List;
  tasks: Task[];
  sprints: Sprint[];
  projectPhases: ProjectPhase[];
};

export const ListDataContext = createContext<ListDataContext | null>(null);

export const ListDataProvider = ({
  children,
  projectId,
}: {
  children: React.ReactNode;
  projectId: number;
}) => {
  const { taskList, sprintList, phaseList, tasks, sprints, projectPhases } =
    useListData(projectId);

  return (
    <ListDataContext.Provider
      value={{
        taskList,
        sprintList,
        phaseList,
        tasks,
        sprints: sprints ?? [],
        projectPhases,
      }}
    >
      {children}
    </ListDataContext.Provider>
  );
};

export const useListDataContext = () => {
  const context = useContext(ListDataContext);

  if (!context) {
    throw new Error(
      'This context hook must be used within a <LookupContextProvider>.',
    );
  }

  return context;
};
